import React from "react";

const HamburgerMenuIcon = ({ onClick }) => (
  <svg
    onClick={onClick}
    class={`mobile-only`}
    style={{
      width: "24px",
      height: "24px",
      marginTop: "auto",
      marginBottom: "auto",
      cursor: "pointer"
    }}
    viewBox="0 0 24 24"
  >
    <path fill="#000000" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
  </svg>
);

export default HamburgerMenuIcon;



// WEBPACK FOOTER //
// ./src/components/NavBar/HamburgerMenuIcon/index.js